import { Image } from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import User from "./User";
import "./TrcHeader.css";
import axios from "axios";

const MagnitHeader = () => {
  const [click, setClick] = useState(false);
  const isMounteref = useRef(true);
  const [logo, setLogo] = useState("");

  const getLogo = async () => {
    let data = await axios.get(
      window.location.origin + "/jsv4/webapi/getCompanyLogo"
    );
    console.log("hghshshfsgfshgfhsgf", data?.data);

    if (data?.data?.status) {
      setLogo(data?.data?.companyLogo);
    }
    isMounteref.current = false;
  };

  useEffect(() => {
    if (isMounteref?.current) {
      console.log(isMounteref?.current,"isMounteref?.currentisMounteref?.current")
      getLogo();
    }
  }, []);

  const handleclick = () => {
    setClick(!click);
  };

  return (
    <div>
      <nav className={"nav nav-white-bg"}>
        <div className="logo">
          <a >
            <Image
                src={logo}
            //   src={"https://magnitcareersqa.maprecruit.com/images/manitglobalIN/logos/690ad9304d81ac2269b6b507_logo_magnit.png"}
              className="headerlogo1 "
            />
          </a>
        </div>

        <div className={click ? "menu active" : "menu"}>
          <div className="ps-0 pb-3 pt-2 d-lg-none d-block">
            <button
              onClick={() => setClick(false)}
              className=" btn-primary btnReset"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div
            className="topheader"
            style={{ display: "flex", alignItems: "center" }}
          >
            <User />
          </div>
        </div>
        <div className="hamburger" onClick={handleclick}>
          {click ? (
            <FontAwesomeIcon icon={faTimes} className="Fatimes" />
          ) : (
            <FontAwesomeIcon icon={faBars} className="Fabars" />
          )}
        </div>
      </nav>
      {click && <div className="overlayBg" onClick={handleclick}></div>}
    </div>
  );
};

export default MagnitHeader;
